import React from "react";
import { A, pillTone } from "../styles/appleClasses";

type BubbleType =
  | "preorder"
  | "fulfilled"
  | "paid"
  | "partial"
  | "unpaid"
  | "voided"
  | "open";

type DotColor = "red" | "yellow" | "green" | "grey" | undefined;

interface StatusBubbleProps {
  label: string;
  bubbleType: BubbleType;
  dotColor?: DotColor;
  className?: string;
  showDot?: boolean;
}

const BUBBLE_STYLE: Record<BubbleType, string> = {
  preorder: pillTone.warning,
  fulfilled: pillTone.neutral,
  paid: pillTone.success,
  partial: pillTone.warning,

  // We don't have a canonical "danger" tone yet, so keep this local for now.
  unpaid: "bg-red-50 text-red-700 ring-red-100",

  // Muted neutral (voided)
  voided: "bg-gray-50 text-gray-400 ring-gray-100",

  // "Open" should be semantic "info" (NOT brand-blue and not tailwind blue-*)
  open: pillTone.info,
};

const DOT_STYLE: Record<Exclude<DotColor, undefined>, string> = {
  red: "bg-red-400",
  yellow: "bg-yellow-400",
  green: "bg-green-400",
  grey: "bg-gray-400",
};

export function StatusBubble({
  label,
  bubbleType,
  dotColor,
  className = "",
  showDot = false,
}: StatusBubbleProps) {
  const showDotActual = !!showDot && !!dotColor;

  return (
    <span
      className={[
        A.pillBase, // ✅ canonical pill shape/typography/ring
        "gap-1.5",
        showDot ? "min-w-6" : "",
        BUBBLE_STYLE[bubbleType],
        className,
      ].join(" ")}
    >
      <span className="truncate">{label}</span>

      {showDotActual && (
        <span
          className={`w-2 h-2 rounded-full inline-block ${DOT_STYLE[dotColor!]}`}
          aria-hidden="true"
        />
      )}
    </span>
  );
}
